import { AlertMargin, StyledAlert } from "App/global-style";
import {
  AlertDescription,
  AlertTitle,
} from "Components/TextContext/commonComponentEnums";

import { useTexts } from "Components/TextContext";
import { useIsAdvisorSelector } from "Store/advisor/advisorSelectors";
import React from "react";
import { AlertType } from "./alertTypes";

export interface Props {
  alertId: string;
  marginTop?: AlertMargin;
}

export const SystemErrorAlert = ({
  alertId,
  marginTop,
}: Props): React.ReactElement => {
  const { getText, createLinkComponent } = useTexts();
  const isAdvisor = useIsAdvisorSelector();

  const phonenumber = getText(AlertDescription.PHONENUMBER_STOREBRAND);
  const description = createLinkComponent(
    AlertDescription.CALL_US_ERROR,
    {
      variables: {
        phoneNumber: {
          text: phonenumber,
          url: `tel:+47${phonenumber.replace(/\s/g, "")}`,
          __type: "hyperlink",
        },
      },
    },
    false,
  );

  return (
    <StyledAlert
      alertId={alertId}
      alertType={AlertType.SYSTEM_ERROR_ALERT}
      title={getText(AlertTitle.SOMETHING_WENT_WRONG)}
      type="error"
      fluid
      marginTop={marginTop}
    >
      {isAdvisor ? getText(AlertDescription.ADVISOR_RETRY) : description}
    </StyledAlert>
  );
};
